/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBellRing: {
  name: 'bell-ring';
  data: string;
} = {
  name: 'bell-ring',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.555 2.832a1 1 0 0 0-1.11-1.664l-3 2a1 1 0 1 0 1.11 1.664l3-2Zm8.613-1.387a1 1 0 0 1 1.387-.277l3 2a1 1 0 0 1-1.11 1.664l-3-2a1 1 0 0 1-.277-1.387ZM12 3a7 7 0 0 0-7 7v4.697l-.795 1.194C3.318 17.22 4.27 19 5.869 19H8a4 4 0 0 0 8 0h2.132c1.597 0 2.55-1.78 1.664-3.11L19 14.698V10a7 7 0 0 0-7-7Zm-2 16a2 2 0 1 0 4 0h-4Zm-3-9a5 5 0 1 1 10 0v4.697a2 2 0 0 0 .336 1.11L18.132 17H5.869l.795-1.193A2 2 0 0 0 7 14.697V10Z" fill="currentColor"/></svg>`,
};
